var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.5,
    fill: "white",
    stroke: "#2D2F31"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5444_10105",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5444_10105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 19C11.0317 19 10.1217 18.8162 9.27 18.4487C8.41833 18.0812 7.6775 17.5825 7.0475 16.9525C6.4175 16.3225 5.91875 15.5817 5.55125 14.73C5.18375 13.8783 5 12.9683 5 12C5 11.0317 5.18375 10.1217 5.55125 9.27C5.91875 8.41833 6.4175 7.6775 7.0475 7.0475C7.6775 6.4175 8.41833 5.91875 9.27 5.55125C10.1217 5.18375 11.0317 5 12 5C12.9683 5 13.8783 5.18375 14.73 5.55125C15.5817 5.91875 16.3225 6.4175 16.9525 7.0475C17.5825 7.6775 18.0812 8.41833 18.4487 9.27C18.8162 10.1217 19 11.0317 19 12C19 12.9683 18.8162 13.8783 18.4487 14.73C18.0812 15.5817 17.5825 16.3225 16.9525 16.9525C16.3225 17.5825 15.5817 18.0812 14.73 18.4487C13.8783 18.8162 12.9683 19 12 19ZM12.7 17.5475C14.0883 17.3725 15.2521 16.7629 16.1912 15.7188C17.1304 14.6746 17.6 13.435 17.6 12C17.6 10.565 17.1304 9.32542 16.1912 8.28125C15.2521 7.23708 14.0883 6.6275 12.7 6.4525V17.5475Z",
    fill: "#2D2F31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark-mode.2755d668fa32364568f0f40011eaf1c6.svg";
export { ForwardRef as ReactComponent };